<script setup lang="ts">
import { NodeViewWrapper } from '@tiptap/vue-3'

defineProps<{
  node: {
    attrs: {
      name: string
    }
  }
}>()
</script>

<template>
  <NodeViewWrapper as="span" class="variable-tag">
    {{ node.attrs.name }}
  </NodeViewWrapper>
</template>

<style>
@reference "@/input.css";

.variable-tag {
  @apply inline-flex items-center px-2 py-0.5 mx-0.5 bg-muted border border-border rounded text-sm font-medium text-foreground-secondary cursor-default select-none;
}
</style>
